"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PANCAKE_SWAP_PROVIDER_CONFIGURATION = exports.PANCAKE_SWAP_CONTRACT_ADDRESS = void 0;
var default_constants_1 = require("../default-constants");
exports.PANCAKE_SWAP_CONTRACT_ADDRESS = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
exports.PANCAKE_SWAP_PROVIDER_CONFIGURATION = default_constants_1.defaultBscProviderConfiguration;
//# sourceMappingURL=constants.js.map